var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighPriestess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326.7 469.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.81,
    y1: 230.65,
    x2: 164.65,
    y2: 220.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 237.96,
    y1: 117.41,
    x2: 164.65,
    y2: 220.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 218.21,
    y1: 22.27,
    x2: 237.96,
    y2: 117.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 299.7,
    y1: 110.63,
    x2: 218.21,
    y2: 22.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 285.13,
    y1: 215.61,
    x2: 299.7,
    y2: 110.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 186.09,
    y1: 284.17,
    x2: 285.13,
    y2: 215.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.81,
    y1: 230.65,
    x2: 186.09,
    y2: 284.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.2,
    y1: 362.99,
    x2: 163.35,
    y2: 362.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 309.5,
    y1: 362.99,
    x2: 163.35,
    y2: 362.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.35,
    y1: 76.14,
    x2: 163.35,
    y2: 362.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.28,
    y1: 444.71,
    x2: 17.2,
    y2: 362.99
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.89 231.65 155.93 220.24 144.89 208.84 160.29 212.7 164.65 197.44 169 212.7 184.4 208.84 173.36 220.24 184.4 231.65 169 227.79 164.65 243.05 160.29 227.79 144.89 231.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.6 87.54 154.64 76.14 143.6 64.74 159 68.59 163.35 53.33 167.71 68.59 183.1 64.74 172.06 76.14 183.1 87.54 167.71 83.68 163.35 98.95 159 83.68 143.6 87.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.22 124.28 229.46 115.53 221.14 102.01 235.34 109.1 242.89 95.14 243.85 110.98 259.71 110.54 246.47 119.29 254.79 132.81 240.59 125.72 233.04 139.68 232.08 123.84 216.22 124.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.79 271.5 184.84 276.08 198.77 266.87 194.19 282.92 203.39 296.85 187.34 292.27 173.42 301.47 178 285.42 168.79 271.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.04 347.83 17.2 354.8 32.37 347.83 25.4 362.99 32.37 378.16 17.2 371.18 2.04 378.16 9.01 362.99 2.04 347.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "163.35 341.54 169.14 357.2 184.8 362.99 169.14 368.78 163.35 384.44 157.56 368.78 141.9 362.99 157.56 357.2 163.35 341.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "90.28 423.26 96.07 438.92 111.73 444.71 96.07 450.51 90.28 466.16 84.48 450.51 68.83 444.71 84.48 438.92 90.28 423.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "324.66 347.83 317.69 362.99 324.66 378.16 309.5 371.18 294.33 378.16 301.31 362.99 294.33 347.83 309.5 354.8 324.66 347.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "226.86 2.64 225.85 19.3 237.84 30.91 221.18 29.9 209.57 41.9 210.58 25.23 198.58 13.62 215.24 14.63 226.86 2.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "281.13 99.9 297.58 102.72 310.42 92.05 307.61 108.51 318.27 121.35 301.82 118.54 288.98 129.2 291.79 112.75 281.13 99.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "46.48 211.34 58.51 222.92 75.12 221.33 63.54 233.35 65.13 249.97 53.11 238.39 36.49 239.98 48.07 227.95 46.48 211.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "276.49 195.98 288.1 207.98 304.76 206.97 292.77 218.58 293.78 235.24 282.17 223.25 265.5 224.26 277.5 212.64 276.49 195.98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPriestess);
export default __webpack_public_path__ + "static/media/HighPriestess.6e70c482f10570a95057c0889e769169.svg";
export { ForwardRef as ReactComponent };